/**
 * Created by agengmaulana on 5/12/17.
 */
import React from 'react'
import styles from './../../assets/css/comment.css'

export default class Comment_Btn extends React.Component{
    constructor(props) {
        super(props)

    }

    render(){
        let share = this.props.share_to
        let share_to = share == 'fb' ? styles.cmt_fb : share == 'tw' ? styles.cmt_tw : ''
        return(
            <a href="javascript:void(0);" className={styles.icon+' '+this.props.class+' '+share_to+' '+styles.cmt_size_box+' '+styles.cmt_href} title={this.props.title} onMouseEnter={this.shorting} onClick={this.props.click} target="_blank"  ><img src={this.props.img} alt={this.props.img}/></a>

        )
    }

    shorting=()=>{
        if(this.props.share_to == 'tw' ){
            // this.props.datFunction.dataShortUrl(this.props.id)
        }
        else {

        }

    }
}


// WEBPACK FOOTER //
// ./static/src/component/comment_share/comment_btn.js